export const HIDE_BUTTON = 'HIDE_BUTTON'
export const LOCK_SCRIPT = 'LOCK_SCRIPT'
export const SHOW_BUTTON = 'SHOW_BUTTON'

export const mutations = {
  [LOCK_SCRIPT]: function (state) {
    state.areScriptsLoaded = true
  },

  [SHOW_BUTTON]: function (state) {
    state.buttonIsVisible = true
  },

  [HIDE_BUTTON]: function (state) {
    state.buttonIsVisible = false
  },
}
